<style lang="less" scoped>
.root-info-contain {
  position: relative;
  margin:5px;
  .root-info-loading {
    z-index: 10;
     position: absolute;
     height: 100%;
     width: 100%;
     background-color: rgba(255,255,255,0.9) solid 1px;
  }
  .border-left-one {
    border-radius: 0;
    border-left: 1px solid rgba(0,0,0,.12);
  }
  .list-contain {
    /deep/.v-list-item__title {
       text-overflow:inherit;
       white-space: normal;
    }
  }
}
.stat-info {
  box-shadow: none!important;
  // display: inline-block;
  border-left: rgba(0,0,0,.12);
  /deep/.v-list-item--two-line {
    min-height: 0 !important;
  }
  /deep/.v-card__text {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  /deep/ .col-3 {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
</style>
<template>
  <div
    class="root-info-contain"
  >
    <div 
      v-show="loading"
      class="root-info-loading"
    >
      <v-progress-linear
        color="primary"
        indeterminate
        reverse
      />
    </div> 
    <v-card>
      <v-card-title>预算申请单</v-card-title>
      <v-list class="list-contain">
        <div style="padding: 0 12px">
          <v-row>
            <v-col cols="5">
              <v-row>
                <v-col cols="6">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{ detail.uid }}</v-list-item-title>
                      <v-list-item-subtitle>申请编号</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="6">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{ detail.name }}</v-list-item-title>
                      <v-list-item-subtitle>审批名称</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="6">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{ (product_teams_hash[detail.apply_team_id]|| {}).full_name }}</v-list-item-title>
                      <v-list-item-subtitle>申请团队</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <!-- 季度起始时间 -->
                <v-col cols="6">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{ detail.apply_user }}</v-list-item-title>
                      <v-list-item-subtitle>申请人</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="6">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{ quarterStart }}</v-list-item-title>
                      <v-list-item-subtitle>季度起始时间</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{ detail.apply_reason }}</v-list-item-title>
                      <v-list-item-subtitle>申请事由</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="7">
              <div class="border-left-one">
                <v-card class="stat-info">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title>
                        科目预算汇总
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-card-text>
                    <v-row>
                      <v-col
                        cols="12"
                      >
                        <DaynamicTable 
                          :table-data="detail.stat_info"
                        /> 
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-list>
    </v-card>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import DaynamicTable from './DaynamicTable'
  export default {
    components: {
      DaynamicTable
    },
    props: {
      detail: {
        type: Object
      },
      loading: {
        type: Boolean
      }
    },
    computed: {
      ...mapGetters('async', {
        product_teams_hash: 'product_teams_hash'
      }),
      quarterStart() {
        const date = (this.detail.quarter_start_at || '').slice(0, 7)
        if (!date) {
          return '-'
        }
        return `${date}【第${Math.ceil(date.slice(-2) / 3)}季度】`
        // quarter_start_at
      }
    }
  }
</script>
